export default __webpack_public_path__ + "static/media/img-teams_1.4c59c2cb.svg";